import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from '@remix-run/react';

const BackButton = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.state.idx === 0) {
      navigate('/');
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="flex h-7 w-7 items-center justify-center rounded-wt transition-all hover:bg-black/5">
      <button className="cursor-pointer" onClick={handleGoBack}>
        <ArrowLeftIcon className="h-6 w-6 stroke-1 text-wt-text-on-background opacity-50" />
      </button>
    </div>
  );
};

export default BackButton;
